import axios from "axios";
import { BACKEND_URL } from "../utils/env.config";
import { DetectOSAndBrowser } from "../redux/api/DetectBroweser";
const api = axios.create({
 baseURL: BACKEND_URL,
 headers: {
  "Client-OS": DetectOSAndBrowser().OS,
  "Client-Browser": DetectOSAndBrowser().Browser,
 },
});

export const signUp = async (formData: FormData) => {
 return await api.post("/Users/SignUp", formData, {
  headers: { "Content-Type": "multipart/form-data" },
 });
};

// Login
export const login = async (credentials: {
 UserName: string;
 Password: string;
}) => {
 return await api.post("/Auth/Login", credentials);
};

// Refresh Token
export const refreshToken = async (tokens: {
 Token: string;
 RefreshToken: string;
}) => {
 return await api.post("/Auth/RefreshToken", tokens);
};

export const forgotPassword = async (email: string) => {
 return await api.get(
  `/Users/ForgetPassword?email=${encodeURIComponent(email)}`
 );
};

export const googleSignin = async (token: string) => {
 return await api.post(`/Auth/GoogleSignIn`, { Token: token });
};
// RESET PASSWORD (POST request)
// The OTP will be used as the old password.
export const resetPassword = async (payload: {
 email: string;
 oldPassword: string;
 newPassword: string;
 confirmPassword: string;
}) => {
 return await api.post("/Users/ResetPassword", {
  Email: payload.email,
  OldPassWord: payload.oldPassword,
  NewPassWord: payload.newPassword,
  ConfirmPassWord: payload.confirmPassword,
 });
};
